import * as THREE from "three";

const loader = new THREE.TextureLoader();

export function loadTexture(url: string): Promise<THREE.Texture> {
  return new Promise((resolve, reject) => {
    loader.load(
      url,
      (tex) => {
        tex.colorSpace = THREE.SRGBColorSpace;
        tex.anisotropy = 8;
        tex.needsUpdate = true;
        resolve(tex);
      },
      undefined,
      (err) => reject(err),
    );
  });
}

/** Load an HTML <img> element so we can paint it into a 2D canvas. */
export function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = (e) => reject(e);
    img.src = url;
  });
}

/** Same, but resolves to null on failure so the rest of the page can still render. */
export async function loadImageOptional(url: string): Promise<HTMLImageElement | null> {
  try {
    return await loadImage(url);
  } catch (e) {
    console.warn(`[loader] could not load ${url}`, e);
    return null;
  }
}

/**
 * Load a custom font via the FontFace API and register it with document.fonts
 * so subsequent canvas draws can use it. Resolves on success, swallows errors
 * (the surrounding code falls back to the system serif stack).
 */
export async function loadFont(family: string, url: string): Promise<void> {
  if (!("FontFace" in window)) return;
  try {
    const face = new FontFace(family, `url("${url}")`);
    const loaded = await face.load();
    (document as any).fonts.add(loaded);
    // Wait for the browser to mark all faces ready so canvas renders pick it up.
    await (document as any).fonts.ready;
  } catch (e) {
    console.warn(`[loader] font ${family} failed to load`, e);
  }
}
